export function getProjectChecklistSchema() {
  return [
    {
      name: "id",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [],
      helperText: "",
      nullable: false,
      readOnly: true,
      error: false,
    },
    {
      name: "template_id",
      default: "",
      type: "string",
      maxLength: 50,
      selectables: [],
      similair: [],
      nullable: false,
      readOnly: false,
      helperText: "Name is required",
      error: false,
    },
    {
      name: "equipment_ids",
      default: "",
      type: "array",
      maxLength: 50,
      selectables: [],
      similair: [],
      nullable: false,
      readOnly: false,
      helperText: "",
      error: false,
    },
    {
      name: "Type",
      default: "",
      type: "string",
      maxLength: 50,
      selectables: ["Pre-Functional", "Receipt Inspection"],
      similair: [],
      nullable: false,
      readOnly: false,
      helperText: "",
      error: false,
    },
    {
      name: "Assigned To",
      default: "",
      type: "string",
      maxLength: 500,
      selectables: ["Designers", "Contractors", "Owners"],
      similair: [],
      nullable: false,
      readOnly: false,
      helperText: "",
      error: false,
    },
  ];
}
